module.exports = __webpack_public_path__ + "img/Avatar-55.e2a1cfd2.svg";